// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999999%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Ccircle cx=%2710.5%27 cy=%2710.5%27 r=%277%27/%3E%3Cline x1=%2721%27 y1=%2721%27 x2=%2716.65%27 y2=%2716.65%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: "DM Sans Variable", sans-serif;
  background: #fcfaf2;
  color: #252629;
  line-height: 1.5;
}

h1, h2 {
  font-family: "berthold-block-w1g", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-transform: uppercase;
  padding-left: 0.7rem;
}

/* Layout */
.site-layout {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.site-header {
  color: #252629;
  padding: 0;
  background: #fcfaf2;
}

.site-header .header-top {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fcfaf2;
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.site-header .header-top > a {
  flex: 0 1 auto;
  min-width: 0;
  line-height: 0;
}

.site-logo-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.site-logo-beta {
  position: absolute;
  right: -17%;
  top: 84%;
  transform: translateY(-50%);
  height: 62%;
  width: auto;
  pointer-events: none;
}

.header-logo {
  height: 40px;
  width: auto;
  max-width: 100%;
  display: block;
}

/* Language menu */
.lang-menu {
  position: relative;
}

.lang-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #fcfaf2;
  border: 1px solid rgba(0,0,0,0.12);
  color: #252629;
  padding: 0;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s;
  font-family: inherit;
}

.lang-toggle:hover { background: rgba(0,0,0,0.1); }

.globe-icon {
  width: 20px;
  height: 20px;
  display: block;
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  min-width: 150px;
  z-index: 300;
  overflow: hidden;
  padding: 0.25rem 0;
}

.lang-dropdown .dropdown-link {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  transition: background 0.1s;
  font-family: inherit;
}

.lang-dropdown .dropdown-link:hover {
  background: #F5F0EB;
}

.lang-dropdown .dropdown-link.active {
  font-weight: 600;
  color: #252629;
}

.lang-dropdown .dropdown-link.active::after {
  content: '✓';
  float: right;
  margin-left: 0.75rem;
}

/* Header sign-in link */
.btn-header-login {
  color: #252629;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.4rem 1rem;
  border: 1px solid rgba(0,0,0,0.15);
  border-radius: 999px;
  transition: background 0.15s, border-color 0.15s;
}

.btn-header-login:hover {
  background: rgba(0,0,0,0.05);
  border-color: rgba(0,0,0,0.3);
}

/* Profile menu */
.profile-menu {
  position: relative;
}

.profile-toggle {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex-shrink: 1;
  justify-self: end;
}

.profile-name {
  color: #252629;
  font-size: 0.85rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 9rem;
}

.profile-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.08);
  color: #252629;
  font-size: 0.9rem;
  font-weight: 600;
  transition: background 0.15s;
}

.profile-toggle:hover .profile-avatar {
  background: rgba(0,0,0,0.15);
}

.profile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  min-width: 180px;
  z-index: 300;
  overflow: hidden;
}

.profile-dropdown-header {
  padding: 0.75rem 1rem 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  color: #252629;
}

.profile-dropdown hr {
  border: none;
  border-top: 1px solid #E8E3DC;
  margin: 0;
}

.profile-dropdown button,
.profile-dropdown .dropdown-link {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  color: #333;
  cursor: pointer;
  transition: background 0.1s;
  text-decoration: none;
  font-family: inherit;
}

.profile-dropdown button:hover,
.profile-dropdown .dropdown-link:hover {
  background: #F5F0EB;
}

.profile-dropdown .dropdown-logout {
  color: #dc3545;
}

.profile-dropdown .dropdown-logout:hover {
  background: #fde8e8;
}

.header-banner {
  aspect-ratio: 2 / 1;
  max-height: 300px;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  background: #c8dcb7  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 50%/auto 90% no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #252629;
  font-family: "berthold-block-w1g", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-transform: uppercase;
  font-size: 1.1rem;
  letter-spacing: 0.05em;
  border-radius: 24px;
  margin: 0.5rem auto;
  width: calc(100% - 1rem);
  max-width: min(1120px, 100% - 1rem);
  text-align: center;
  overflow-wrap: anywhere;
  hyphens: auto;
}

.header-banner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
}

.header-banner-text {
  font-size: clamp(1.1rem, 3.5vw,1.4rem);
  line-height: 1.1;
}

.header-banner-buttons {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-banner {
  border: none;
  border-radius: 999px;
  padding: 0.45rem 1.1rem;
  font-family: "DM Sans Variable", sans-serif;
  font-weight: 600;
  font-size: clamp(.4rem, 1.7vw, .5rem);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #252629;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.05s ease;
  white-space: nowrap;
}

.btn-banner:hover {
  filter: brightness(0.95);
}

.btn-banner:active {
  transform: translateY(1px);
}

.btn-banner-rent {
  background: #ff8a7c;
}

.btn-banner-offer {
  background: #ffebcc;
}

nav {
  min-width: 0;
  justify-self: center;
}

nav .nav-inner {
  display: flex;
  gap: 1.25rem;
  justify-content: center;
  overflow-x: auto;
}

nav a {
  background: none;
  border: none;
  padding: 0.25rem 0;
  font-size: 0.875rem;
  font-weight: 400;
  color: #252629;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  transition: color 0.15s;
  font-family: inherit;
}

nav a:hover { color: #252629; }
nav a.active {
  color: #252629;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.global-error-banner {
  position: fixed;
  top: var(--global-error-top, 0px);
  left: 0;
  right: 0;
  z-index: 500;
  padding: 0 1rem 0.5rem;
  pointer-events: none;
}

.global-error-banner__inner {
  max-width: 1120px;
  margin: 0 auto;
  pointer-events: auto;
}

.global-error-banner .alert {
  margin-bottom: 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.main-content {
  flex: 1 1;
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.5rem;
  width: 100%;
}

/* Alerts */
.alert {
  padding: 0.75rem 1rem;
  border-radius: 16px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alert-error { background: #fde8e8; color: #c62828; }
.alert-success { background: #e8f5e9; color: #2e7d32; }
.alert-warning { background: #fff8e1; color: #f57f17; }
.alert .dismiss { background: none; border: none; cursor: pointer; font-size: 1.1rem; color: inherit; opacity: 0.6; padding: 0 0.25rem; }
.alert .dismiss:hover { opacity: 1; }

/* Toast */
.toast-container {
  position: fixed;
  bottom: 1.25rem;
  left: 0;
  right: 0;
  z-index: 600;
  display: flex;
  justify-content: center;
  padding: 0 1rem;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  max-width: 32rem;
  padding: 0.75rem 1rem;
  border-radius: 16px;
  font-size: 0.9rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  pointer-events: auto;
  animation: toast-in 0.2s ease-out;
}

.toast--success { background: #e8f5e9; color: #2e7d32; }
.toast--error { background: #fde8e8; color: #c62828; }

.toast__message { flex: 1 1; }

.toast__dismiss {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  color: inherit;
  opacity: 0.6;
  padding: 0 0.25rem;
}

.toast__dismiss:hover { opacity: 1; }

@keyframes toast-in {
  from { opacity: 0; transform: translateY(0.5rem); }
  to { opacity: 1; transform: translateY(0); }
}

/* Cards */
.card {
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 16px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  transition: box-shadow 0.15s;
}

.card:hover {
  /*box-shadow: 0 2px 12px rgba(0,0,0,0.06);*/
}

/* Product grid */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.25rem;
}

.product-tile {
  background: #f6f1e4;
  border: 0 solid #E8E3DC;
  border-radius: 16px;
  overflow: hidden;
  transition: box-shadow 0.15s, transform 0.15s;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.product-tile:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); transform: translateY(-2px); }

.product-tile:focus-visible {
  outline: 2px solid #252629;
  outline-offset: 2px;
}

.product-tile .tile-image {
  width: 100%;
  height: 200px;
  background: #f6f1e4;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  border-radius: 12px;
  margin: 0;
}

.product-tile .tile-image img { width: 100%; height: 100%; object-fit: cover; }

.product-tile .tile-image [role="button"]:focus-visible {
  outline: 2px solid #252629;
  outline-offset: 2px;
}

.product-detail-modal__image {
  height: min(50vh, 420px);
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #111;
}

.product-detail-modal__image [role="button"] {
  cursor: zoom-in;
}

/* Fullscreen image lightbox */
.image-lightbox {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.image-lightbox__stage {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.image-lightbox__img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  transform-origin: center center;
  pointer-events: none;
  -webkit-user-drag: none;
}

.image-lightbox__close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 1.75rem;
  line-height: 1;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  cursor: pointer;
}

.image-lightbox__close:hover {
  background: rgba(255, 255, 255, 0.22);
}

.image-lightbox__toolbar {
  position: absolute;
  bottom: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  gap: 0.5rem;
}

.image-lightbox__zoom-btn {
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 1.35rem;
  line-height: 1;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  cursor: pointer;
}

.image-lightbox__zoom-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.24);
}

.image-lightbox__zoom-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

.image-lightbox__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 2rem;
  line-height: 1;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-lightbox__nav:hover {
  background: rgba(255, 255, 255, 0.24);
}

.image-lightbox__nav--prev { left: 0.75rem; }
.image-lightbox__nav--next { right: 0.75rem; }

.image-lightbox__counter {
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  color: #fff;
  font-size: 0.85rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}

.product-detail-modal__desc {
  font-size: 0.95rem;
  color: #555;
  white-space: pre-wrap;
  margin-bottom: 1rem;
  line-height: 1.45;
}

.product-tile .tile-body {
  padding: 1rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.product-tile .tile-body h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.product-tile .tile-body .tile-desc {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0.75rem;
  flex: 1 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-tile .tile-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}

.product-tile .tile-price {
  font-size: 1.1rem;
  font-weight: 400;
  color: #252629;
}

/* Guarantee icon beside tile price */
.guarantee-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  object-fit: contain;
}
.guarantee-icon-link { display: inline-flex; align-items: center; }

/* Make the guarantee control an icon-only button (no default button chrome) */
.guarantee-icon-link {
  background: transparent;
  border: none;
  padding: 4px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.12s ease, transform 0.06s ease;
  line-height: 0;
}
.guarantee-icon-link img { display: block; }
.guarantee-icon-link:hover { background: rgba(200, 220, 183, 0.22); }
.guarantee-icon-link:active { transform: translateY(1px); }
.guarantee-icon-link:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(200, 220, 183, 0.28);
}

/* Product detail guarantee banner */
.guarantee-banner {
  background: #c8dcb7; /* green from design */
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
  color: #21321a;
  font-weight: 600;
}
.guarantee-banner img {
  width: 28px;
  height: auto;
  max-height: 28px;
  object-fit: contain;
  display: block;
}
.guarantee-banner a { color: inherit; text-decoration: underline; }

.lender-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem 0.65rem;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  line-height: 1.2;
}

.lender-meta-identity {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.lender-meta-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

a.lender-meta-name {
  color: inherit;
  text-decoration: none;
}

a.lender-meta-name:hover {
  text-decoration: underline;
  color: #1a5fb4;
}

.lender-meta-rating {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
}

.lender-meta-rating-text {
  font-size: 0.85rem;
  line-height: 1;
}

.user-profile-header {
  margin-bottom: 1.5rem;
}

.user-profile-header__identity {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.5rem;
}

.user-profile-header__name {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  color: #252629;
}

.user-profile-header__verified {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: #d4edda;
  color: #155724;
  font-size: 0.8rem;
  font-weight: 600;
}

.user-profile-header__verified--no {
  background: #f0f0f0;
  color: #6c757d;
}

.user-profile-header__rating {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}

.user-profile-header__location {
  max-width: 480px;
}


/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.1rem;
  font-size: 0.85rem;
  font-weight: 500;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  text-decoration: none;
  gap: 0.4rem;
}

.btn.btn-blocked {
  cursor: default;
  background-color: #aaa;
}

.btn.btn-blocked:hover {
  cursor: default;
  background-color: #aaa;
}

.btn-primary { background: #252629; color: #fff; }
.btn-primary:hover { background: #16213e; }
.btn-accent { background: #c7dbb5; color: #252629; }
.btn-accent:hover { background: #b7cba5; }
.btn-secondary { background: #E8E3DC; color: #333; }
.btn-secondary:hover { background: #DDD8D0; }
.btn-danger { background: #dc3545; color: #fff; }
.btn-danger:hover { background: #c82333; }
.btn-sm { padding: 0.35rem 0.75rem; font-size: 0.8rem; }

/* Button spinner */
.btn-spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  animation: btn-spin 0.6s linear infinite;
}

@keyframes btn-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Handover waiting block */
.handover-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.75rem;
  padding: 0.85rem 0.75rem;
  border: 1px dashed var(--color-border, #ddd);
  border-radius: 8px;
  background: #fff;
  text-align: center;
}

.handover-waiting-message {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  color: #444;
}

.handover-waiting-hint {
  font-size: 0.78rem;
  margin: 0;
}

.handover-waiting-url {
  font-size: 0.72rem;
  margin: 0;
  word-break: break-all;
}

.waiting-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: 1.25rem;
}

.waiting-indicator span {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: #888;
  animation: waiting-bounce 1.2s ease-in-out infinite;
}

.waiting-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}

.waiting-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes waiting-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-0.35rem);
    opacity: 1;
  }
}

/* Forms */
.form-group { margin-bottom: 0.85rem; }
.form-group label { display: block; font-size: 0.8rem; font-weight: 600; color: #555; margin-bottom: 0.25rem; }

.dob-input { display: flex; gap: 0.5rem; align-items: center; }
.dob-input input { width: auto; flex: 0 0 auto; text-align: center; }
.dob-input__segment--day,
.dob-input__segment--month { max-width: 3.5rem; }
.dob-input__segment--year { max-width: 5rem; }
.dob-input__separator { color: #888; -webkit-user-select: none; user-select: none; }

input:not([type="checkbox"]):not([type="radio"]), textarea, select {
  width: 100%;
  padding: 0.55rem 0.75rem;
  border: 1px solid #DDD8D0;
  border-radius: 10px;
  font-size: 0.9rem;
  font-family: inherit;
  transition: border-color 0.15s;
  background: #fff;
}

input[type="checkbox"],
input[type="radio"] {
  width: auto;
  padding: 0;
  flex-shrink: 0;
}

input:focus, textarea:focus, select:focus { outline: none; border-color: #252629; }
textarea { resize: vertical; min-height: 80px; }

/* Photo manager */
.photo-manager { margin-top: 0.35rem; }
.photo-manager__empty { font-size: 0.85rem; margin: 0 0 0.5rem; }
.photo-manager__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.photo-manager__reorder-hint { font-size: 0.8rem; margin: 0 0 0.5rem; }
.photo-manager__thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--color-border, #DDD8D0);
  background: #EDE8E0;
}
.photo-manager__thumb[draggable="true"] { cursor: grab; }
.photo-manager__thumb--dragging { opacity: 0.4; }
.photo-manager__thumb--drop-target {
  outline: 2px solid #252629;
  outline-offset: -2px;
}
.photo-manager__move {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.45);
}
.photo-manager__move button {
  flex: 1 1;
  border: none;
  background: none;
  color: #fff;
  font-size: 1rem;
  line-height: 1;
  padding: 3px 0;
  cursor: pointer;
}
.photo-manager__move button:hover:not(:disabled) { background: rgba(0, 0, 0, 0.35); }
.photo-manager__move button:disabled { opacity: 0.35; cursor: not-allowed; }
.photo-manager__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.photo-manager__remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.photo-manager__remove:hover:not(:disabled) { background: rgba(0, 0, 0, 0.75); }
.photo-manager__remove:disabled { opacity: 0.5; cursor: not-allowed; }
.photo-manager__count { font-size: 0.8rem; margin: 0 0 0.5rem; }
.photo-manager__add-zone {
  border: 2px dashed var(--color-border, #DDD8D0);
  border-radius: 10px;
  padding: 0.85rem;
  text-align: center;
  transition: border-color 0.15s, background-color 0.15s;
}
.photo-manager__add-zone--active {
  border-color: #252629;
  background: var(--color-surface-alt, #f8f9fa);
}
.photo-manager__add-zone--disabled { opacity: 0.65; }
.photo-manager__drop-hint {
  font-size: 0.85rem;
  color: #666;
  margin: 0 0 0.6rem;
}
.photo-manager__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
}
.photo-manager__hidden-input {
  display: none !important;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}
.form-row > .form-group { margin-bottom: 0; }

@media (min-width: 769px) {
  .form-row {
    flex-direction: row;
  }
  .form-row > * {
    flex: 1 1;
    min-width: 0;
  }
}

.form-actions { display: flex; gap: 0.5rem; margin-top: 1rem; }

.form-legend { font-size: 0.8rem; color: #888; margin-bottom: 0.75rem; }
.required-marker { color: #c62828; }

.form-submitted input:invalid,
.form-submitted textarea:invalid,
.form-submitted select:invalid {
  border-color: #c62828;
  background: #fef5f5;
}

.form-group--error .dob-input__segment,
.dob-input--invalid .dob-input__segment {
  border-color: #c62828;
  background: #fef5f5;
}

.field-error {
  font-size: 0.8rem;
  color: #c62828;
  margin-top: 0.25rem;
}

/* Search */
.search-bar {
  margin-bottom: 1.25rem;
}

.search-bar input {
  padding-left: 2.5rem;
  height: 2.75rem;
  border-radius: 999px;
  border: 1px solid #DDD8D0;
  font-size: 0.95rem;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 0.85rem center;
  background-size: 1.1rem;
}

.product-filters {
  margin-bottom: 1.25rem;
  border: 1px solid #DDD8D0;
  border-radius: 12px;
  background: #FAF8F5;
  overflow: hidden;
}

.product-filters__heading {
  margin: 0;
  padding: 0.55rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #888;
  border-bottom: 1px solid #E8E3DC;
}

.product-filters__list {
  display: flex;
  flex-direction: column;
}

.product-filter + .product-filter {
  border-top: 1px solid #E8E3DC;
}

.product-filter__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  padding: 0.65rem 1rem;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  color: #252629;
  cursor: pointer;
  text-align: left;
}

.product-filter__summary:hover {
  background: #F3EFE8;
}

.product-filter__summary-text {
  flex: 1 1;
  min-width: 0;
}

.product-filter__chevron {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: #888;
}

.product-filter--expanded .product-filter__summary {
  background: #F3EFE8;
}

.product-filter__panel {
  padding: 0 1rem 1rem;
  border-top: 1px solid #E8E3DC;
  background: #FFFDFB;
}

.location-filter__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0.85rem 0 0.35rem;
}

.location-filter__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #252629;
}

.location-filter__map-hint {
  font-size: 0.8rem;
  margin: 0 0 0.5rem;
}

.location-filter__map {
  margin-bottom: 0.35rem;
}

.location-filter__distance {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

.location-filter__distance select {
  min-width: 6rem;
}

.date-filter__label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #252629;
  margin: 0.85rem 0 0.5rem;
}

.date-filter__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
}

.date-filter__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.85rem;
  min-width: 10rem;
}

.date-filter__field input[type='date'] {
  padding: 0.45rem 0.55rem;
  border: 1px solid #DDD8D0;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #fff;
}

.owner-filter__field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.85rem;
}

.owner-filter__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #252629;
}

.owner-filter__field input[type='text'] {
  padding: 0.45rem 0.55rem;
  border: 1px solid #DDD8D0;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #fff;
  max-width: 20rem;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.35rem;
  margin-top: 1.5rem;
}

.pagination .btn { min-width: 2.2rem; text-align: center; }
.pagination .btn:disabled { opacity: 0.45; cursor: default; }

.pagination-ellipsis {
  padding: 0 0.25rem;
  color: #999;
  -webkit-user-select: none;
          user-select: none;
}

/* Section titles */
.section-title {
  font-size: 1.25rem;
  font-weight: 400;
  margin-bottom: 1rem;
  color: #252629;
}

/* Account page tabs */
.account-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #E8E3DC;
}

.account-tabs button {
  background: none;
  border: none;
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.account-tabs button.active { color: #252629; font-weight: 600; border-bottom-color: #E8604C; }

/* Login page */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  background: #fff;
  border-radius: 20px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}

.login-card h1 { font-size: 1.5rem; margin-bottom: 0.25rem; color: #252629; }
.login-card .login-subtitle { color: #888; font-size: 0.9rem; margin-bottom: 1.5rem; }

/* Manage products list */
.manage-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #EDE8E0;
}

.manage-item--clickable {
  cursor: pointer;
}

.manage-item--clickable:hover {
  background: rgba(0, 0, 0, 0.02);
}

.manage-item:last-child { border-bottom: none; }

.manage-item .item-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  flex: 1 1;
  min-width: 0;
}

.manage-item .item-details {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.manage-item .item-name {
  overflow-wrap: anywhere;
}

.manage-item .item-actions {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

/* Orders */
.order-card { border-left: 3px solid #252629; }
.order-card h3 { font-size: 1rem; margin-bottom: 0.5rem; }
.order-meta { font-size: 0.85rem; color: #666; }
.order-total { font-size: 1.05rem; font-weight: 700; margin-top: 0.5rem; }

.rental-price-summary {
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #f8f9fa;
}
.rental-price-summary__rate {
  font-size: 0.9rem;
  color: #666;
}
.rental-price-summary__total {
  margin-top: 0.35rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #252629;
}
.rental-price-summary__hint {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: #888;
}

.price-breakdown {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.9rem;
}
.price-breakdown__row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  color: #444;
}
.price-breakdown__row--total {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e0e0e0;
  font-weight: 700;
  color: #252629;
  font-size: 1rem;
}
.price-breakdown__row span:last-child {
  text-align: right;
}

/* Rental modal overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  padding: 1rem;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  box-sizing: border-box;
  overflow-y: auto;
}

.modal-overlay .modal-overlay {
  z-index: 210;
}

.modal {
  position: relative;
  background: #fff;
  border-radius: 20px;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  max-height: calc(100vh - 2rem);
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  margin: auto;
}

.modal--wide {
  max-width: 560px;
}

.modal--scroll {
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
}

.modal--scroll .modal__body {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-bottom: 1rem;
}

.modal__title {
  font-size: 1.15rem;
  margin: 0;
  line-height: 1.3;
  flex: 1 1;
  min-width: 0;
}

.modal__close {
  flex-shrink: 0;
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  padding: 0.15rem 0.35rem;
  color: #666;
  border-radius: 4px;
}

.modal__close:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #222;
}

.modal__close--floating {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1;
}

.modal--floating-close .modal__body {
  padding-top: 1.75rem;
}

/* Forgot password link */
.forgot-link {
  color: #6c757d;
  font-size: 0.85rem;
  text-decoration: none;
  transition: color 0.15s;
}

.forgot-link:hover {
  color: #252629;
  text-decoration: underline;
}

/* Order status badges */
.order-status {
  display: inline-block;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.order-status-0 { background: #fff3cd; color: #856404; }
.order-status-1 { background: #d4edda; color: #155724; }
.order-status-2 { background: #f8d7da; color: #721c24; }
.order-status-3 { background: #d6eaf8; color: #1565c0; }
.order-status-4 { background: #f8d7da; color: #721c24; }

/* Utility */
.text-muted { color: #888; font-size: 0.85rem; margin-bottom: 1.25rem; }
.mt-1 { margin-top: 0.5rem; }
.mb-1 { margin-bottom: 0.5rem; }

/* Tooltip */
.tooltip-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
}

.tooltip-icon {
  background: none;
  border: none;
  padding: 0;
  margin-left: 0.25rem;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ccc;
  font-size: 0.75rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  color: #555;
}

.tooltip-icon:focus {
  outline: 2px solid #252629;
  outline-offset: 2px;
}

.tooltip-bubble {
  position: fixed;
  width: max-content;
  max-width: 280px;
  background: #252629;
  color: #fff;
  padding: 0.5rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.18);
  z-index: 300;
  pointer-events: none;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* How it works page */
.how-it-works {
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 16px;
  padding: 1.5rem;
}

.how-it-works h2 {
  margin-bottom: 1rem;
}

.how-it-works section {
  margin-bottom: 1.25rem;
}

.how-it-works h3 {
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #252629;
}

.how-it-works p {
  color: #333;
  margin-bottom: 0;
}

/* Terms page */
.terms-page {
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 16px;
  padding: 1.5rem;
}

.terms-page h2 {
  margin-bottom: 1rem;
}

.terms-version + .terms-version {
  margin-top: 2rem;
}

.terms-version h3 {
  margin-bottom: 0.75rem;
}

.terms-pdf {
  width: 100%;
  height: 80vh;
  border: none;
  border-radius: 8px;
}

/* FAQ page */
.faq-page {
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 16px;
  padding: 1.5rem;
}

.faq-page h2 {
  margin-bottom: 1rem;
}

.faq-item {
  margin-bottom: 1.25rem;
}

.faq-item h3 {
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #252629;
}

.faq-item p {
  color: #333;
  margin-bottom: 0;
}

/* Guarantee page */
.guarantee-page {
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 16px;
  padding: 1.5rem;
}

.guarantee-page h2 {
  margin-bottom: 1rem;
}

.guarantee-page section {
  margin-bottom: 1.25rem;
}

.guarantee-page h3 {
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #252629;
}

.guarantee-page p {
  color: #333;
  margin-bottom: 0.5rem;
}

.guarantee-page ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  color: #333;
}

.guarantee-page ul li {
  margin-bottom: 0.3rem;
}

.guarantee-page a {
  color: #2D6A4F;
  text-decoration: underline;
}

/* Footer */
.site-footer {
  margin-top: 3rem;
}

.footer-main {
  background: #FEF2DF;
  border-top: 1px solid #E8E3DC;
}

.footer-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.footer-company {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.85rem;
  color: #252629;
}

.footer-company a {
  color: inherit;
  text-decoration: none;
}

.footer-company a:hover {
  text-decoration: underline;
}

.footer-registry {
  font-size: 0.75rem;
  opacity: 0.75;
}

.footer-company strong {
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.footer-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.footer-logo {
  height: 50px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
}

.footer-links a,
.footer-links .report-content-link {
  color: #252629;
  text-decoration: none;
  transition: color 0.15s;
}

.footer-links a:hover,
.footer-links .report-content-link:hover {
  text-decoration: underline;
}

.report-content-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 0.85rem;
  color: #888;
  text-decoration: underline;
  cursor: pointer;
}

.footer-link-sep {
  color: #999;
}

.footer-social {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.footer-social-icons {
  display: flex;
  gap: 0.5rem;
}

.social-icon {
  color: #252629;
  transition: opacity 0.15s;
}

.social-icon:hover {
  opacity: 0.7;
}

.footer-follow-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #252629;
  border: 1.5px solid #252629;
  border-radius: 3px;
  padding: 0.25rem 0.6rem;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.footer-bottom {
  background: #252629;
  color: #fff;
  font-size: 0.8rem;
  padding: 0.75rem 1.5rem;
}

.footer-bottom-lower {
  display: block;
  max-width: 1120px;
  margin: 0 auto;
}

.footer-bottom-lower a {
  color: inherit;
}

.footer-commit {
  opacity: 0.6;
}

@media (max-width: 700px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
  .footer-social {
    justify-content: center;
  }
}

.site-header .header-top--stacked {
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  gap: 0.75rem 1rem;
}

.site-header .header-top--stacked > a {
  grid-column: 1;
  grid-row: 1;
}

.site-header .header-top--stacked .header-actions {
  grid-column: 2;
  grid-row: 1;
}

.site-header .header-top--stacked nav {
  grid-column: 1 / -1;
  grid-row: 2;
  justify-self: stretch;
  width: 100%;
}

.site-header .header-top--stacked nav .nav-inner {
  gap: 0.75rem;
  justify-content: flex-start;
}

.site-header .header-top--stacked nav a {
  font-size: 0.82rem;
}

@media (max-width: 480px) {
  .site-header .header-top {
    padding: 0.85rem 0.5rem;
  }

  .header-logo {
    height: 34px;
    max-width: min(140px, 42vw);
    object-fit: contain;
    object-position: left center;
  }

  .header-actions {
    gap: 0.35rem;
  }

  .lang-toggle {
    width: 32px;
    height: 32px;
  }

  .globe-icon {
    width: 18px;
    height: 18px;
  }

  .btn-header-login {
    padding: 0.35rem 0.65rem;
    font-size: 0.78rem;
  }

  .profile-toggle {
    gap: 0.35rem;
  }

  .profile-avatar {
    width: 32px;
    height: 32px;
    font-size: 0.85rem;
  }

  .profile-name {
    max-width: 6rem;
    font-size: 0.78rem;
  }

  .main-content {
    padding: 1rem 0;
  }

  .header-banner {
    width: 100%;
    max-width: none;
    margin-left: 0;
    margin-right: 0;
    border-radius: 0;
    min-height: 0;
    font-size: 0.95rem;
    letter-spacing: 0.03em;
    padding: 0.85rem 0.5rem;
  }
}

/* Admin user table */
.table-responsive {
  overflow-x: auto;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.admin-table th,
.admin-table td {
  padding: 0.6rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

.admin-table th {
  font-weight: 600;
  background: rgba(0, 0, 0, 0.03);
}

.badge {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 600;
}

.badge-success {
  background: #d4edda;
  color: #155724;
}

.badge-muted {
  background: rgba(0, 0, 0, 0.08);
  color: #555;
}

.badge-warning {
  background: #fff3cd;
  color: #856404;
}

.badge-wishlist {
  background: #e8d5ff;
  color: #5b21b6;
}

.search-log-row--wishlist {
  background: rgba(139, 92, 246, 0.08);
}

.search-log-row--wishlist td:first-child {
  box-shadow: inset 3px 0 0 #8b5cf6;
}

.search-wishlist-panel {
  margin-top: 1rem;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(139, 92, 246, 0.25);
  border-radius: 8px;
  background: rgba(139, 92, 246, 0.06);
  max-width: 36rem;
}

.search-wishlist-panel__intro {
  margin: 0 0 0.5rem;
}

.search-wishlist-panel__privacy {
  margin: 0 0 0.75rem;
  font-size: 0.88rem;
}

.search-wishlist-panel__success {
  margin: 0;
  color: #5b21b6;
  font-weight: 600;
}

.admin-table-expand-col {
  width: 2.5rem;
}

.admin-table-expand-btn {
  min-width: 2rem;
  padding: 0.2rem 0.4rem;
  line-height: 1;
}

.admin-table-row-expanded td {
  background: rgba(0, 0, 0, 0.02);
}

.admin-user-detail-row td {
  padding: 0;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.admin-user-detail {
  padding: 1rem 1.25rem 1.25rem 2.75rem;
}

.admin-user-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.75rem 1.5rem;
  margin: 0;
}

.admin-user-detail-field dt {
  font-size: 0.78rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.15rem;
}

.admin-user-detail-field dd {
  margin: 0;
  font-size: 0.9rem;
  word-break: break-word;
}

.admin-user-edit-form {
  margin-bottom: 0;
}

.admin-user-edit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.75rem 1.5rem;
}

.admin-user-checkbox-field label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-weight: 500;
  margin-top: 1.75rem;
}

.admin-user-readonly-section {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.75rem 1.5rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.admin-user-readonly-field {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.admin-user-readonly-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #666;
}

.admin-user-readonly-value {
  font-size: 0.9rem;
  word-break: break-word;
}

.admin-user-password-form {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.admin-user-password-title {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
}

.subsection-title {
  margin: 0 0 0.75rem;
  font-size: 1.05rem;
  font-weight: 600;
}

/* Rental availability calendar */
.rental-date-picker {
  margin-bottom: 0.75rem;
}

.rental-date-picker__calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;
}

.rental-date-picker__calendar--disabled {
  opacity: 0.65;
  pointer-events: none;
}

.rental-date-picker__loading {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
}

.rental-date-picker__fetch-error {
  margin-bottom: 0.5rem;
  width: 100%;
}

/* Doubled class so these beat react-day-picker's own .rdp-root defaults, which load later. */
.rdp-root.rental-day-picker {
  --rdp-accent-color: #252629;
  --rdp-accent-background-color: #c7dbb5;
  --rdp-today-color: #4a7a35;
}

.rental-day-picker {
  --rdp-day-height: 36px;
  --rdp-day-width: 36px;
  font-size: 0.9rem;
}

.rental-day-picker .rdp-day--unavailable {
  background: #E8E3DC;
  color: #8a847b;
  font-weight: 600;
}

.rental-day-picker .rdp-day--preview:not(.rdp-disabled) {
  background: rgba(199, 219, 181, 0.45);
}

.rental-date-picker__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  justify-content: center;
  margin-bottom: 0.35rem;
  font-size: 0.8rem;
}

.rental-date-picker__legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.rental-date-picker__legend-item::before {
  content: '';
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.rental-date-picker__legend-item--unavailable::before {
  background: #E8E3DC;
  border-color: #DDD8D0;
}

.rental-date-picker__legend-item--selected::before {
  background: #c7dbb5;
  border-color: #252629;
}

.rental-date-picker__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.rental-date-picker__field {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.45rem 0.65rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-width: 0;
}

.rental-date-picker__field--active {
  border-color: #252629;
  box-shadow: 0 0 0 2px #c7dbb5;
}

.rental-date-picker__field--error {
  border-color: #c62828;
}

.rental-date-picker__field-label {
  font-size: 0.8rem;
  color: #666;
}

.rental-date-picker__field-value {
  font-weight: 600;
  color: #252629;
}

.rental-date-picker__field-value--empty {
  font-weight: 400;
  color: #888;
}

/* Rent modal steps */
.rent-steps {
  display: flex;
  gap: 0.5rem;
  list-style: none;
  margin: 0 0 1rem;
  padding: 0;
  font-size: 0.85rem;
  color: #888;
}

.rent-steps__item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding-bottom: 0.4rem;
  border-bottom: 3px solid #e0e0e0;
  min-width: 0;
}

.rent-steps__item--done {
  color: #444;
  border-bottom-color: #c8dcb7;
}

.rent-steps__item--current {
  color: #252629;
  font-weight: 600;
  border-bottom-color: #252629;
}

.rent-steps__number {
  flex-shrink: 0;
  width: 1.4rem;
  height: 1.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eceff1;
  font-size: 0.75rem;
}

.rent-steps__item--current .rent-steps__number {
  background: #252629;
  color: #fff;
}

.rent-assurances {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.875rem;
  color: #444;
}

.rent-assurances__item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.rent-assurances__item::before {
  content: '✓';
  flex-shrink: 0;
  width: 22px;
  text-align: center;
  color: #4a7a35;
  font-weight: 700;
}

.rent-assurances__item--guarantee::before {
  display: none;
}

.rent-assurances__item img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.rent-location {
  margin-top: 1rem;
}

.rent-location__title {
  margin: 0;
  font-weight: 600;
  font-size: 0.95rem;
}

.rent-location__hint {
  margin: 0.15rem 0 0.5rem;
  font-size: 0.85rem;
  color: #666;
}

.rent-contact-preview {
  padding: 0.75rem;
  border: 1px solid var(--color-border, #ddd);
  border-radius: 6px;
  background: var(--color-surface, #fafafa);
  font-size: 0.875rem;
}

.rent-contact-preview__title {
  margin: 0 0 0.35rem;
  color: #444;
}

.rent-contact-preview__list {
  list-style: none;
  margin: 0 0 0.35rem;
  padding: 0;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.rent-contact-preview__edit {
  font-size: 0.8rem;
}

.rent-summary {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.35rem 1rem;
  margin: 0 0 1rem;
  font-size: 0.9rem;
}

.rent-summary dt {
  color: #666;
}

.rent-summary dd {
  margin: 0;
  font-weight: 600;
}

.rent-summary__notes {
  font-weight: 400 !important;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.rent-legal {
  font-size: 0.82rem;
  color: #666;
}

.rent-legal__title {
  margin: 0 0 0.35rem;
  font-weight: 600;
  color: #444;
}

.rent-legal__list {
  margin: 0 0 0.5rem;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.rent-terms-toggle {
  background: none;
  border: none;
  padding: 0;
  margin: 0 0 0.5rem;
  font: inherit;
  font-size: 0.85rem;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.manage-unavailable__list {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
}

.manage-unavailable__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--color-border, #ddd);
}

.manage-unavailable__item:last-child {
  border-bottom: none;
}

.manage-unavailable__form {
  margin-top: 0.5rem;
}

/* Categories overview */
.categories-page {
  max-width: 1120px;
  margin: 0 auto;
}

.category-tile-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
}

.category-tile {
  position: relative;
  display: block;
  aspect-ratio: 4 / 5;
  border-radius: 20px;
  background: #F3EFE9;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
}

.category-tile-heading {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 2.5rem 1rem 1rem;
  font-family: "berthold-block-w1g", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  color: #252629;
  line-height: 1.2;
}

.category-tile:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.category-tile:focus-visible {
  outline: 2px solid #252629;
  outline-offset: 2px;
}

.category-tile-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 3.5rem;
  width: 100%;
  height: 100%;
  padding: 1.25rem 1rem 0.5rem;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center;
}

@media (max-width: 768px) {
  .category-tile-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .category-tile-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .category-tile {
    border-radius: 14px;
  }

  .category-tile-heading {
    padding: 2rem 0.6rem 0.75rem;
    font-size: 0.72rem;
  }
}

/* Search view toggle */
.view-toggle {
  display: inline-flex;
  gap: 0;
  margin-bottom: 1rem;
  border: 1px solid #E8E3DC;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.view-toggle__btn {
  border: none;
  background: transparent;
  padding: 0.45rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #252629;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.view-toggle__btn:hover {
  background: #f6f1e4;
}

.view-toggle__btn--active {
  background: #252629;
  color: #fff;
}

.view-toggle__btn--active:hover {
  background: #252629;
}

.view-toggle__btn:focus-visible {
  outline: 2px solid #252629;
  outline-offset: -2px;
}

/* Search results map */
.search-results-map {
  position: relative;
  width: 100%;
  min-height: 60vh;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #E8E3DC;
  margin-bottom: 1rem;
  z-index: 1;
}

.search-results-map__canvas {
  width: 100%;
  height: 60vh;
  min-height: 360px;
}

.search-results-map--loading::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(246, 241, 228, 0.55);
  z-index: 1000;
  pointer-events: none;
}

.map-results-notice {
  font-size: 0.85rem;
  margin: 0 0 0.75rem;
}

.leaflet-marker-icon.map-price-marker {
  width: auto !important;
  height: auto !important;
  transform: translate(-50%, -100%);
  background: #fff;
  color: #252629;
  border: 1px solid #E8E3DC;
  border-radius: 999px;
  padding: 0.35rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: transform 0.12s, background 0.12s, border-color 0.12s, box-shadow 0.12s;
}

.leaflet-marker-icon.map-price-marker:hover,
.leaflet-marker-icon.map-price-marker--selected {
  background: #252629;
  color: #fff;
  border-color: #252629;
  transform: translate(-50%, -100%) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  z-index: 1000 !important;
}

.map-cluster-icon-wrap {
  background: transparent;
  border: none;
}

.map-cluster-marker {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #252629;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 2px solid #fff;
}

.map-product-card {
  position: absolute;
  z-index: 1100;
  transform: translate(-50%, calc(-100% - 14px));
  display: flex;
  gap: 0.5rem;
  width: min(240px, calc(100% - 1rem));
  padding: 0.5rem;
  background: #fff;
  border: 1px solid #E8E3DC;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);
  pointer-events: none;
}

.map-product-card__image {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #EDE8E0;
}

.map-product-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.map-product-card__placeholder {
  width: 100%;
  height: 100%;
  background: #EDE8E0;
}

.map-product-card__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.15rem;
}

.map-product-card__name {
  font-size: 0.82rem;
  font-weight: 600;
  color: #252629;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.map-product-card__price {
  font-size: 0.75rem;
  color: #666;
}

@media (max-width: 768px) {
  .search-results-map,
  .search-results-map__canvas {
    min-height: 70vh;
    height: 70vh;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,qBAAqB,2BAA2B,EAAE;;AAElD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,mFAAsE;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,cAAc,cAAc,EAAE;AAC9B;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,kBAAkB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACxI,wBAAwB,UAAU,EAAE;;AAEpC,UAAU;AACV;EACE,eAAe;EACf,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD,kBAAkB,SAAO,EAAE;;AAE3B;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA,wBAAwB,UAAU,EAAE;;AAEpC;EACE,OAAO,UAAU,EAAE,6BAA6B,EAAE;EAClD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,sBAAsB,uCAAuC,EAAE,2BAA2B,EAAE;;AAE5F;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gCAAgC,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;;AAE9E;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6BAA6B,aAAa,EAAE;AAC5C,6BAA6B,cAAc,EAAE;;AAE7C;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,SAAO;EACP,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;AACA,uBAAuB,oBAAoB,EAAE,mBAAmB,EAAE;;AAElE,8EAA8E;AAC9E;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uDAAuD;EACvD,cAAc;AAChB;AACA,2BAA2B,cAAc,EAAE;AAC3C,6BAA6B,qCAAqC,EAAE;AACpE,8BAA8B,0BAA0B,EAAE;AAC1D;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA,sBAAsB,cAAc,EAAE,0BAA0B,EAAE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,eAAe,mBAAmB,EAAE,WAAW,EAAE;AACjD,qBAAqB,mBAAmB,EAAE;AAC1C,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,oBAAoB,mBAAmB,EAAE;AACzC,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;AACnD,uBAAuB,mBAAmB,EAAE;AAC5C,cAAc,mBAAmB,EAAE,WAAW,EAAE;AAChD,oBAAoB,mBAAmB,EAAE;AACzC,UAAU,wBAAwB,EAAE,iBAAiB,EAAE;;AAEvD,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,+BAA+B;IAC/B,UAAU;EACZ;AACF;;AAEA,UAAU;AACV,cAAc,sBAAsB,EAAE;AACtC,oBAAoB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE,sBAAsB,EAAE;;AAE9G,aAAa,aAAa,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAC9D,mBAAmB,WAAW,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACpE;6BAC6B,iBAAiB,EAAE;AAChD,4BAA4B,eAAe,EAAE;AAC7C,wBAAwB,WAAW,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;;AAExD;EACE,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA,4CAA4C,aAAa,EAAE,qBAAqB,EAAE;AAClF,WAAW,gBAAgB,EAAE,gBAAgB,EAAE;;AAE/C,kBAAkB;AAClB,iBAAiB,mBAAmB,EAAE;AACtC,wBAAwB,kBAAkB,EAAE,kBAAkB,EAAE;AAChE;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;AACA,+BAA+B,iBAAiB,EAAE,kBAAkB,EAAE;AACtE;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA,0CAA0C,YAAY,EAAE;AACxD,kCAAkC,YAAY,EAAE;AAChD;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA,mDAAmD,+BAA+B,EAAE;AACpF,uCAAuC,aAAa,EAAE,mBAAmB,EAAE;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,8CAA8C,+BAA+B,EAAE;AAC/E,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;AACrE,wBAAwB,iBAAiB,EAAE,kBAAkB,EAAE;AAC/D;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA,qCAAqC,aAAa,EAAE;AACpD;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;AACA,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE;IACE,mBAAmB;EACrB;EACA;IACE,SAAW;IACX,YAAY;EACd;AACF;;AAEA,gBAAgB,aAAa,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAE9D,eAAe,iBAAiB,EAAE,WAAW,EAAE,sBAAsB,EAAE;AACvE,mBAAmB,cAAc,EAAE;;AAEnC;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,yDAA+S;EAC/S,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mBAAmB,iBAAiB,EAAE,kBAAkB,EAAE;AAC1D,4BAA4B,aAAa,EAAE,eAAe,EAAE;;AAE5D;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oCAAoC;AACtC;;AAEA,8BAA8B,cAAc,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAE9F,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,iBAAiB,iBAAiB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AAC5E,8BAA8B,WAAW,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;;AAErF,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA,WAAW;AACX,cAAc,8BAA8B,EAAE;AAC9C,iBAAiB,eAAe,EAAE,qBAAqB,EAAE;AACzD,cAAc,kBAAkB,EAAE,WAAW,EAAE;AAC/C,eAAe,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEzE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD,YAAY;AACZ,cAAc,WAAW,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACvE,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,qBAAqB,EAAE;;AAE/B,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA,6FAA6F;AAC7F;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;EACT,yBAAyB;EACzB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,MAAM;EACN,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,mFAAmF;AACrF;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6CAA6C;EAC7C,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;IAEE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\nbody {\n  font-family: \"DM Sans Variable\", sans-serif;\n  background: #fcfaf2;\n  color: #252629;\n  line-height: 1.5;\n}\n\nh1, h2 {\n  font-family: \"berthold-block-w1g\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  text-transform: uppercase;\n  padding-left: 0.7rem;\n}\n\n/* Layout */\n.site-layout {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\n.site-header {\n  color: #252629;\n  padding: 0;\n  background: #fcfaf2;\n}\n\n.site-header .header-top {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: #fcfaf2;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 1.25rem 1.5rem;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.site-header .header-top > a {\n  flex: 0 1 auto;\n  min-width: 0;\n  line-height: 0;\n}\n\n.site-logo-wrap {\n  position: relative;\n  display: inline-block;\n  line-height: 0;\n}\n\n.site-logo-beta {\n  position: absolute;\n  right: -17%;\n  top: 84%;\n  transform: translateY(-50%);\n  height: 62%;\n  width: auto;\n  pointer-events: none;\n}\n\n.header-logo {\n  height: 40px;\n  width: auto;\n  max-width: 100%;\n  display: block;\n}\n\n/* Language menu */\n.lang-menu {\n  position: relative;\n}\n\n.lang-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #fcfaf2;\n  border: 1px solid rgba(0,0,0,0.12);\n  color: #252629;\n  padding: 0;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s;\n  font-family: inherit;\n}\n\n.lang-toggle:hover { background: rgba(0,0,0,0.1); }\n\n.globe-icon {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.lang-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.12);\n  min-width: 150px;\n  z-index: 300;\n  overflow: hidden;\n  padding: 0.25rem 0;\n}\n\n.lang-dropdown .dropdown-link {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0.6rem 1rem;\n  font-size: 0.85rem;\n  color: #333;\n  cursor: pointer;\n  transition: background 0.1s;\n  font-family: inherit;\n}\n\n.lang-dropdown .dropdown-link:hover {\n  background: #F5F0EB;\n}\n\n.lang-dropdown .dropdown-link.active {\n  font-weight: 600;\n  color: #252629;\n}\n\n.lang-dropdown .dropdown-link.active::after {\n  content: '✓';\n  float: right;\n  margin-left: 0.75rem;\n}\n\n/* Header sign-in link */\n.btn-header-login {\n  color: #252629;\n  text-decoration: none;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 0.4rem 1rem;\n  border: 1px solid rgba(0,0,0,0.15);\n  border-radius: 999px;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.btn-header-login:hover {\n  background: rgba(0,0,0,0.05);\n  border-color: rgba(0,0,0,0.3);\n}\n\n/* Profile menu */\n.profile-menu {\n  position: relative;\n}\n\n.profile-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n  flex-shrink: 1;\n  justify-self: end;\n}\n\n.profile-name {\n  color: #252629;\n  font-size: 0.85rem;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 9rem;\n}\n\n.profile-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(0,0,0,0.08);\n  color: #252629;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: background 0.15s;\n}\n\n.profile-toggle:hover .profile-avatar {\n  background: rgba(0,0,0,0.15);\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.12);\n  min-width: 180px;\n  z-index: 300;\n  overflow: hidden;\n}\n\n.profile-dropdown-header {\n  padding: 0.75rem 1rem 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #252629;\n}\n\n.profile-dropdown hr {\n  border: none;\n  border-top: 1px solid #E8E3DC;\n  margin: 0;\n}\n\n.profile-dropdown button,\n.profile-dropdown .dropdown-link {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0.6rem 1rem;\n  font-size: 0.85rem;\n  color: #333;\n  cursor: pointer;\n  transition: background 0.1s;\n  text-decoration: none;\n  font-family: inherit;\n}\n\n.profile-dropdown button:hover,\n.profile-dropdown .dropdown-link:hover {\n  background: #F5F0EB;\n}\n\n.profile-dropdown .dropdown-logout {\n  color: #dc3545;\n}\n\n.profile-dropdown .dropdown-logout:hover {\n  background: #fde8e8;\n}\n\n.header-banner {\n  aspect-ratio: 2 / 1;\n  max-height: 300px;\n  box-sizing: border-box;\n  padding: 0.75rem 1rem;\n  background: #c8dcb7  url('./assets/banner.svg') 50%/auto 90% no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #252629;\n  font-family: \"berthold-block-w1g\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  letter-spacing: 0.05em;\n  border-radius: 24px;\n  margin: 0.5rem auto;\n  width: calc(100% - 1rem);\n  max-width: min(1120px, 100% - 1rem);\n  text-align: center;\n  overflow-wrap: anywhere;\n  hyphens: auto;\n}\n\n.header-banner-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n}\n\n.header-banner-text {\n  font-size: clamp(1.1rem, 3.5vw,1.4rem);\n  line-height: 1.1;\n}\n\n.header-banner-buttons {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.btn-banner {\n  border: none;\n  border-radius: 999px;\n  padding: 0.45rem 1.1rem;\n  font-family: \"DM Sans Variable\", sans-serif;\n  font-weight: 600;\n  font-size: clamp(.4rem, 1.7vw, .5rem);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #252629;\n  cursor: pointer;\n  transition: filter 0.15s ease, transform 0.05s ease;\n  white-space: nowrap;\n}\n\n.btn-banner:hover {\n  filter: brightness(0.95);\n}\n\n.btn-banner:active {\n  transform: translateY(1px);\n}\n\n.btn-banner-rent {\n  background: #ff8a7c;\n}\n\n.btn-banner-offer {\n  background: #ffebcc;\n}\n\nnav {\n  min-width: 0;\n  justify-self: center;\n}\n\nnav .nav-inner {\n  display: flex;\n  gap: 1.25rem;\n  justify-content: center;\n  overflow-x: auto;\n}\n\nnav a {\n  background: none;\n  border: none;\n  padding: 0.25rem 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: #252629;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: none;\n  transition: color 0.15s;\n  font-family: inherit;\n}\n\nnav a:hover { color: #252629; }\nnav a.active {\n  color: #252629;\n  font-weight: 400;\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.global-error-banner {\n  position: fixed;\n  top: var(--global-error-top, 0px);\n  left: 0;\n  right: 0;\n  z-index: 500;\n  padding: 0 1rem 0.5rem;\n  pointer-events: none;\n}\n\n.global-error-banner__inner {\n  max-width: 1120px;\n  margin: 0 auto;\n  pointer-events: auto;\n}\n\n.global-error-banner .alert {\n  margin-bottom: 0;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.main-content {\n  flex: 1;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 1.5rem;\n  width: 100%;\n}\n\n/* Alerts */\n.alert {\n  padding: 0.75rem 1rem;\n  border-radius: 16px;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.alert-error { background: #fde8e8; color: #c62828; }\n.alert-success { background: #e8f5e9; color: #2e7d32; }\n.alert-warning { background: #fff8e1; color: #f57f17; }\n.alert .dismiss { background: none; border: none; cursor: pointer; font-size: 1.1rem; color: inherit; opacity: 0.6; padding: 0 0.25rem; }\n.alert .dismiss:hover { opacity: 1; }\n\n/* Toast */\n.toast-container {\n  position: fixed;\n  bottom: 1.25rem;\n  left: 0;\n  right: 0;\n  z-index: 600;\n  display: flex;\n  justify-content: center;\n  padding: 0 1rem;\n  pointer-events: none;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  max-width: 32rem;\n  padding: 0.75rem 1rem;\n  border-radius: 16px;\n  font-size: 0.9rem;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);\n  pointer-events: auto;\n  animation: toast-in 0.2s ease-out;\n}\n\n.toast--success { background: #e8f5e9; color: #2e7d32; }\n.toast--error { background: #fde8e8; color: #c62828; }\n\n.toast__message { flex: 1; }\n\n.toast__dismiss {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  color: inherit;\n  opacity: 0.6;\n  padding: 0 0.25rem;\n}\n\n.toast__dismiss:hover { opacity: 1; }\n\n@keyframes toast-in {\n  from { opacity: 0; transform: translateY(0.5rem); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Cards */\n.card {\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 16px;\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n  transition: box-shadow 0.15s;\n}\n\n.card:hover {\n  /*box-shadow: 0 2px 12px rgba(0,0,0,0.06);*/\n}\n\n/* Product grid */\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 1.25rem;\n}\n\n.product-tile {\n  background: #f6f1e4;\n  border: 0 solid #E8E3DC;\n  border-radius: 16px;\n  overflow: hidden;\n  transition: box-shadow 0.15s, transform 0.15s;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.product-tile:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); transform: translateY(-2px); }\n\n.product-tile:focus-visible {\n  outline: 2px solid #252629;\n  outline-offset: 2px;\n}\n\n.product-tile .tile-image {\n  width: 100%;\n  height: 200px;\n  background: #f6f1e4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  border-radius: 12px;\n  margin: 0;\n}\n\n.product-tile .tile-image img { width: 100%; height: 100%; object-fit: cover; }\n\n.product-tile .tile-image [role=\"button\"]:focus-visible {\n  outline: 2px solid #252629;\n  outline-offset: 2px;\n}\n\n.product-detail-modal__image {\n  height: min(50vh, 420px);\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  background: #111;\n}\n\n.product-detail-modal__image [role=\"button\"] {\n  cursor: zoom-in;\n}\n\n/* Fullscreen image lightbox */\n.image-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 400;\n  background: rgba(0, 0, 0, 0.92);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  touch-action: none;\n  user-select: none;\n}\n\n.image-lightbox__stage {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.image-lightbox__img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  transform-origin: center center;\n  pointer-events: none;\n  -webkit-user-drag: none;\n}\n\n.image-lightbox__close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 2;\n  border: none;\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  font-size: 1.75rem;\n  line-height: 1;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.image-lightbox__close:hover {\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.image-lightbox__toolbar {\n  position: absolute;\n  bottom: 1.25rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.image-lightbox__zoom-btn {\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n  font-size: 1.35rem;\n  line-height: 1;\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.image-lightbox__zoom-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.image-lightbox__zoom-btn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.image-lightbox__nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  border: none;\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n  font-size: 2rem;\n  line-height: 1;\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-lightbox__nav:hover {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.image-lightbox__nav--prev { left: 0.75rem; }\n.image-lightbox__nav--next { right: 0.75rem; }\n\n.image-lightbox__counter {\n  position: absolute;\n  top: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2;\n  color: #fff;\n  font-size: 0.85rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);\n  pointer-events: none;\n}\n\n.product-detail-modal__desc {\n  font-size: 0.95rem;\n  color: #555;\n  white-space: pre-wrap;\n  margin-bottom: 1rem;\n  line-height: 1.45;\n}\n\n.product-tile .tile-body {\n  padding: 1rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.product-tile .tile-body h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.product-tile .tile-body .tile-desc {\n  font-size: 0.85rem;\n  color: #666;\n  margin-bottom: 0.75rem;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.product-tile .tile-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n}\n\n.product-tile .tile-price {\n  font-size: 1.1rem;\n  font-weight: 400;\n  color: #252629;\n}\n\n/* Guarantee icon beside tile price */\n.guarantee-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  object-fit: contain;\n}\n.guarantee-icon-link { display: inline-flex; align-items: center; }\n\n/* Make the guarantee control an icon-only button (no default button chrome) */\n.guarantee-icon-link {\n  background: transparent;\n  border: none;\n  padding: 4px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.12s ease, transform 0.06s ease;\n  line-height: 0;\n}\n.guarantee-icon-link img { display: block; }\n.guarantee-icon-link:hover { background: rgba(200, 220, 183, 0.22); }\n.guarantee-icon-link:active { transform: translateY(1px); }\n.guarantee-icon-link:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(200, 220, 183, 0.28);\n}\n\n/* Product detail guarantee banner */\n.guarantee-banner {\n  background: #c8dcb7; /* green from design */\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  margin-bottom: 0.75rem;\n  color: #21321a;\n  font-weight: 600;\n}\n.guarantee-banner img {\n  width: 28px;\n  height: auto;\n  max-height: 28px;\n  object-fit: contain;\n  display: block;\n}\n.guarantee-banner a { color: inherit; text-decoration: underline; }\n\n.lender-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.65rem;\n  margin-top: 0.25rem;\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n.lender-meta-identity {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.lender-meta-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\na.lender-meta-name {\n  color: inherit;\n  text-decoration: none;\n}\n\na.lender-meta-name:hover {\n  text-decoration: underline;\n  color: #1a5fb4;\n}\n\n.lender-meta-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  flex-shrink: 0;\n}\n\n.lender-meta-rating-text {\n  font-size: 0.85rem;\n  line-height: 1;\n}\n\n.user-profile-header {\n  margin-bottom: 1.5rem;\n}\n\n.user-profile-header__identity {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.user-profile-header__name {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #252629;\n}\n\n.user-profile-header__verified {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  background: #d4edda;\n  color: #155724;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.user-profile-header__verified--no {\n  background: #f0f0f0;\n  color: #6c757d;\n}\n\n.user-profile-header__rating {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-bottom: 0.75rem;\n}\n\n.user-profile-header__location {\n  max-width: 480px;\n}\n\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1.1rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n  text-decoration: none;\n  gap: 0.4rem;\n}\n\n.btn.btn-blocked {\n  cursor: default;\n  background-color: #aaa;\n}\n\n.btn.btn-blocked:hover {\n  cursor: default;\n  background-color: #aaa;\n}\n\n.btn-primary { background: #252629; color: #fff; }\n.btn-primary:hover { background: #16213e; }\n.btn-accent { background: #c7dbb5; color: #252629; }\n.btn-accent:hover { background: #b7cba5; }\n.btn-secondary { background: #E8E3DC; color: #333; }\n.btn-secondary:hover { background: #DDD8D0; }\n.btn-danger { background: #dc3545; color: #fff; }\n.btn-danger:hover { background: #c82333; }\n.btn-sm { padding: 0.35rem 0.75rem; font-size: 0.8rem; }\n\n/* Button spinner */\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  animation: btn-spin 0.6s linear infinite;\n}\n\n@keyframes btn-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Handover waiting block */\n.handover-waiting {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.6rem;\n  margin-top: 0.75rem;\n  padding: 0.85rem 0.75rem;\n  border: 1px dashed var(--color-border, #ddd);\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n}\n\n.handover-waiting-message {\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin: 0;\n  color: #444;\n}\n\n.handover-waiting-hint {\n  font-size: 0.78rem;\n  margin: 0;\n}\n\n.handover-waiting-url {\n  font-size: 0.72rem;\n  margin: 0;\n  word-break: break-all;\n}\n\n.waiting-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  height: 1.25rem;\n}\n\n.waiting-indicator span {\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 50%;\n  background: #888;\n  animation: waiting-bounce 1.2s ease-in-out infinite;\n}\n\n.waiting-indicator span:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.waiting-indicator span:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes waiting-bounce {\n  0%, 80%, 100% {\n    transform: translateY(0);\n    opacity: 0.45;\n  }\n  40% {\n    transform: translateY(-0.35rem);\n    opacity: 1;\n  }\n}\n\n/* Forms */\n.form-group { margin-bottom: 0.85rem; }\n.form-group label { display: block; font-size: 0.8rem; font-weight: 600; color: #555; margin-bottom: 0.25rem; }\n\n.dob-input { display: flex; gap: 0.5rem; align-items: center; }\n.dob-input input { width: auto; flex: 0 0 auto; text-align: center; }\n.dob-input__segment--day,\n.dob-input__segment--month { max-width: 3.5rem; }\n.dob-input__segment--year { max-width: 5rem; }\n.dob-input__separator { color: #888; user-select: none; }\n\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]), textarea, select {\n  width: 100%;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #DDD8D0;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  transition: border-color 0.15s;\n  background: #fff;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  width: auto;\n  padding: 0;\n  flex-shrink: 0;\n}\n\ninput:focus, textarea:focus, select:focus { outline: none; border-color: #252629; }\ntextarea { resize: vertical; min-height: 80px; }\n\n/* Photo manager */\n.photo-manager { margin-top: 0.35rem; }\n.photo-manager__empty { font-size: 0.85rem; margin: 0 0 0.5rem; }\n.photo-manager__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.photo-manager__reorder-hint { font-size: 0.8rem; margin: 0 0 0.5rem; }\n.photo-manager__thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid var(--color-border, #DDD8D0);\n  background: #EDE8E0;\n}\n.photo-manager__thumb[draggable=\"true\"] { cursor: grab; }\n.photo-manager__thumb--dragging { opacity: 0.4; }\n.photo-manager__thumb--drop-target {\n  outline: 2px solid #252629;\n  outline-offset: -2px;\n}\n.photo-manager__move {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  background: rgba(0, 0, 0, 0.45);\n}\n.photo-manager__move button {\n  flex: 1;\n  border: none;\n  background: none;\n  color: #fff;\n  font-size: 1rem;\n  line-height: 1;\n  padding: 3px 0;\n  cursor: pointer;\n}\n.photo-manager__move button:hover:not(:disabled) { background: rgba(0, 0, 0, 0.35); }\n.photo-manager__move button:disabled { opacity: 0.35; cursor: not-allowed; }\n.photo-manager__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.photo-manager__remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.photo-manager__remove:hover:not(:disabled) { background: rgba(0, 0, 0, 0.75); }\n.photo-manager__remove:disabled { opacity: 0.5; cursor: not-allowed; }\n.photo-manager__count { font-size: 0.8rem; margin: 0 0 0.5rem; }\n.photo-manager__add-zone {\n  border: 2px dashed var(--color-border, #DDD8D0);\n  border-radius: 10px;\n  padding: 0.85rem;\n  text-align: center;\n  transition: border-color 0.15s, background-color 0.15s;\n}\n.photo-manager__add-zone--active {\n  border-color: #252629;\n  background: var(--color-surface-alt, #f8f9fa);\n}\n.photo-manager__add-zone--disabled { opacity: 0.65; }\n.photo-manager__drop-hint {\n  font-size: 0.85rem;\n  color: #666;\n  margin: 0 0 0.6rem;\n}\n.photo-manager__actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.photo-manager__hidden-input {\n  display: none !important;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n.form-row > .form-group { margin-bottom: 0; }\n\n@media (min-width: 769px) {\n  .form-row {\n    flex-direction: row;\n  }\n  .form-row > * {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n}\n\n.form-actions { display: flex; gap: 0.5rem; margin-top: 1rem; }\n\n.form-legend { font-size: 0.8rem; color: #888; margin-bottom: 0.75rem; }\n.required-marker { color: #c62828; }\n\n.form-submitted input:invalid,\n.form-submitted textarea:invalid,\n.form-submitted select:invalid {\n  border-color: #c62828;\n  background: #fef5f5;\n}\n\n.form-group--error .dob-input__segment,\n.dob-input--invalid .dob-input__segment {\n  border-color: #c62828;\n  background: #fef5f5;\n}\n\n.field-error {\n  font-size: 0.8rem;\n  color: #c62828;\n  margin-top: 0.25rem;\n}\n\n/* Search */\n.search-bar {\n  margin-bottom: 1.25rem;\n}\n\n.search-bar input {\n  padding-left: 2.5rem;\n  height: 2.75rem;\n  border-radius: 999px;\n  border: 1px solid #DDD8D0;\n  font-size: 0.95rem;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23999999' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='10.5' cy='10.5' r='7'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 0.85rem center;\n  background-size: 1.1rem;\n}\n\n.product-filters {\n  margin-bottom: 1.25rem;\n  border: 1px solid #DDD8D0;\n  border-radius: 12px;\n  background: #FAF8F5;\n  overflow: hidden;\n}\n\n.product-filters__heading {\n  margin: 0;\n  padding: 0.55rem 1rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #888;\n  border-bottom: 1px solid #E8E3DC;\n}\n\n.product-filters__list {\n  display: flex;\n  flex-direction: column;\n}\n\n.product-filter + .product-filter {\n  border-top: 1px solid #E8E3DC;\n}\n\n.product-filter__summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.65rem 1rem;\n  border: none;\n  background: transparent;\n  font-size: 0.9rem;\n  color: #252629;\n  cursor: pointer;\n  text-align: left;\n}\n\n.product-filter__summary:hover {\n  background: #F3EFE8;\n}\n\n.product-filter__summary-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.product-filter__chevron {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  color: #888;\n}\n\n.product-filter--expanded .product-filter__summary {\n  background: #F3EFE8;\n}\n\n.product-filter__panel {\n  padding: 0 1rem 1rem;\n  border-top: 1px solid #E8E3DC;\n  background: #FFFDFB;\n}\n\n.location-filter__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0.85rem 0 0.35rem;\n}\n\n.location-filter__label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #252629;\n}\n\n.location-filter__map-hint {\n  font-size: 0.8rem;\n  margin: 0 0 0.5rem;\n}\n\n.location-filter__map {\n  margin-bottom: 0.35rem;\n}\n\n.location-filter__distance {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n}\n\n.location-filter__distance select {\n  min-width: 6rem;\n}\n\n.date-filter__label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #252629;\n  margin: 0.85rem 0 0.5rem;\n}\n\n.date-filter__fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n}\n\n.date-filter__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.85rem;\n  min-width: 10rem;\n}\n\n.date-filter__field input[type='date'] {\n  padding: 0.45rem 0.55rem;\n  border: 1px solid #DDD8D0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: #fff;\n}\n\n.owner-filter__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.85rem;\n}\n\n.owner-filter__label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #252629;\n}\n\n.owner-filter__field input[type='text'] {\n  padding: 0.45rem 0.55rem;\n  border: 1px solid #DDD8D0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: #fff;\n  max-width: 20rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.35rem;\n  margin-top: 1.5rem;\n}\n\n.pagination .btn { min-width: 2.2rem; text-align: center; }\n.pagination .btn:disabled { opacity: 0.45; cursor: default; }\n\n.pagination-ellipsis {\n  padding: 0 0.25rem;\n  color: #999;\n  user-select: none;\n}\n\n/* Section titles */\n.section-title {\n  font-size: 1.25rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n  color: #252629;\n}\n\n/* Account page tabs */\n.account-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 1.25rem;\n  border-bottom: 1px solid #E8E3DC;\n}\n\n.account-tabs button {\n  background: none;\n  border: none;\n  padding: 0.6rem 1rem;\n  font-size: 0.85rem;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.account-tabs button.active { color: #252629; font-weight: 600; border-bottom-color: #E8604C; }\n\n/* Login page */\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 2.5rem 2rem;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n}\n\n.login-card h1 { font-size: 1.5rem; margin-bottom: 0.25rem; color: #252629; }\n.login-card .login-subtitle { color: #888; font-size: 0.9rem; margin-bottom: 1.5rem; }\n\n/* Manage products list */\n.manage-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #EDE8E0;\n}\n\n.manage-item--clickable {\n  cursor: pointer;\n}\n\n.manage-item--clickable:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.manage-item:last-child { border-bottom: none; }\n\n.manage-item .item-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.9rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.manage-item .item-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.manage-item .item-name {\n  overflow-wrap: anywhere;\n}\n\n.manage-item .item-actions {\n  display: flex;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n/* Orders */\n.order-card { border-left: 3px solid #252629; }\n.order-card h3 { font-size: 1rem; margin-bottom: 0.5rem; }\n.order-meta { font-size: 0.85rem; color: #666; }\n.order-total { font-size: 1.05rem; font-weight: 700; margin-top: 0.5rem; }\n\n.rental-price-summary {\n  margin-top: 0.75rem;\n  padding: 0.75rem 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  background: #f8f9fa;\n}\n.rental-price-summary__rate {\n  font-size: 0.9rem;\n  color: #666;\n}\n.rental-price-summary__total {\n  margin-top: 0.35rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #252629;\n}\n.rental-price-summary__hint {\n  margin: 0.35rem 0 0;\n  font-size: 0.85rem;\n  color: #888;\n}\n\n.price-breakdown {\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.9rem;\n}\n.price-breakdown__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  color: #444;\n}\n.price-breakdown__row--total {\n  margin-top: 0.25rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #e0e0e0;\n  font-weight: 700;\n  color: #252629;\n  font-size: 1rem;\n}\n.price-breakdown__row span:last-child {\n  text-align: right;\n}\n\n/* Rental modal overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  padding: 1rem;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.modal-overlay .modal-overlay {\n  z-index: 210;\n}\n\n.modal {\n  position: relative;\n  background: #fff;\n  border-radius: 20px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 420px;\n  max-height: calc(100vh - 2rem);\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n  margin: auto;\n}\n\n.modal--wide {\n  max-width: 560px;\n}\n\n.modal--scroll {\n  max-height: calc(100vh - 2rem);\n  display: flex;\n  flex-direction: column;\n}\n\n.modal--scroll .modal__body {\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-shrink: 0;\n  margin-bottom: 1rem;\n}\n\n.modal__title {\n  font-size: 1.15rem;\n  margin: 0;\n  line-height: 1.3;\n  flex: 1;\n  min-width: 0;\n}\n\n.modal__close {\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0.15rem 0.35rem;\n  color: #666;\n  border-radius: 4px;\n}\n\n.modal__close:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: #222;\n}\n\n.modal__close--floating {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 1;\n}\n\n.modal--floating-close .modal__body {\n  padding-top: 1.75rem;\n}\n\n/* Forgot password link */\n.forgot-link {\n  color: #6c757d;\n  font-size: 0.85rem;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.forgot-link:hover {\n  color: #252629;\n  text-decoration: underline;\n}\n\n/* Order status badges */\n.order-status {\n  display: inline-block;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n.order-status-0 { background: #fff3cd; color: #856404; }\n.order-status-1 { background: #d4edda; color: #155724; }\n.order-status-2 { background: #f8d7da; color: #721c24; }\n.order-status-3 { background: #d6eaf8; color: #1565c0; }\n.order-status-4 { background: #f8d7da; color: #721c24; }\n\n/* Utility */\n.text-muted { color: #888; font-size: 0.85rem; margin-bottom: 1.25rem; }\n.mt-1 { margin-top: 0.5rem; }\n.mb-1 { margin-bottom: 0.5rem; }\n\n/* Tooltip */\n.tooltip-wrapper {\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n}\n\n.tooltip-icon {\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: 0.25rem;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid #ccc;\n  font-size: 0.75rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n  color: #555;\n}\n\n.tooltip-icon:focus {\n  outline: 2px solid #252629;\n  outline-offset: 2px;\n}\n\n.tooltip-bubble {\n  position: fixed;\n  width: max-content;\n  max-width: 280px;\n  background: #252629;\n  color: #fff;\n  padding: 0.5rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.18);\n  z-index: 300;\n  pointer-events: none;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* How it works page */\n.how-it-works {\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.how-it-works h2 {\n  margin-bottom: 1rem;\n}\n\n.how-it-works section {\n  margin-bottom: 1.25rem;\n}\n\n.how-it-works h3 {\n  font-size: 1rem;\n  margin-bottom: 0.3rem;\n  color: #252629;\n}\n\n.how-it-works p {\n  color: #333;\n  margin-bottom: 0;\n}\n\n/* Terms page */\n.terms-page {\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.terms-page h2 {\n  margin-bottom: 1rem;\n}\n\n.terms-version + .terms-version {\n  margin-top: 2rem;\n}\n\n.terms-version h3 {\n  margin-bottom: 0.75rem;\n}\n\n.terms-pdf {\n  width: 100%;\n  height: 80vh;\n  border: none;\n  border-radius: 8px;\n}\n\n/* FAQ page */\n.faq-page {\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.faq-page h2 {\n  margin-bottom: 1rem;\n}\n\n.faq-item {\n  margin-bottom: 1.25rem;\n}\n\n.faq-item h3 {\n  font-size: 1rem;\n  margin-bottom: 0.3rem;\n  color: #252629;\n}\n\n.faq-item p {\n  color: #333;\n  margin-bottom: 0;\n}\n\n/* Guarantee page */\n.guarantee-page {\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.guarantee-page h2 {\n  margin-bottom: 1rem;\n}\n\n.guarantee-page section {\n  margin-bottom: 1.25rem;\n}\n\n.guarantee-page h3 {\n  font-size: 1rem;\n  margin-bottom: 0.3rem;\n  color: #252629;\n}\n\n.guarantee-page p {\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.guarantee-page ul {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n  color: #333;\n}\n\n.guarantee-page ul li {\n  margin-bottom: 0.3rem;\n}\n\n.guarantee-page a {\n  color: #2D6A4F;\n  text-decoration: underline;\n}\n\n/* Footer */\n.site-footer {\n  margin-top: 3rem;\n}\n\n.footer-main {\n  background: #FEF2DF;\n  border-top: 1px solid #E8E3DC;\n}\n\n.footer-inner {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 2rem 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.footer-company {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.85rem;\n  color: #252629;\n}\n\n.footer-company a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.footer-company a:hover {\n  text-decoration: underline;\n}\n\n.footer-registry {\n  font-size: 0.75rem;\n  opacity: 0.75;\n}\n\n.footer-company strong {\n  font-size: 0.95rem;\n  margin-bottom: 0.25rem;\n}\n\n.footer-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.footer-logo {\n  height: 50px;\n}\n\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.85rem;\n}\n\n.footer-links a,\n.footer-links .report-content-link {\n  color: #252629;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.footer-links a:hover,\n.footer-links .report-content-link:hover {\n  text-decoration: underline;\n}\n\n.report-content-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  font-size: 0.85rem;\n  color: #888;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.footer-link-sep {\n  color: #999;\n}\n\n.footer-social {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.footer-social-icons {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.social-icon {\n  color: #252629;\n  transition: opacity 0.15s;\n}\n\n.social-icon:hover {\n  opacity: 0.7;\n}\n\n.footer-follow-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #252629;\n  border: 1.5px solid #252629;\n  border-radius: 3px;\n  padding: 0.25rem 0.6rem;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.footer-bottom {\n  background: #252629;\n  color: #fff;\n  font-size: 0.8rem;\n  padding: 0.75rem 1.5rem;\n}\n\n.footer-bottom-lower {\n  display: block;\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n.footer-bottom-lower a {\n  color: inherit;\n}\n\n.footer-commit {\n  opacity: 0.6;\n}\n\n@media (max-width: 700px) {\n  .footer-inner {\n    flex-direction: column;\n    text-align: center;\n    gap: 1.5rem;\n  }\n  .footer-social {\n    justify-content: center;\n  }\n}\n\n.site-header .header-top--stacked {\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto;\n  gap: 0.75rem 1rem;\n}\n\n.site-header .header-top--stacked > a {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.site-header .header-top--stacked .header-actions {\n  grid-column: 2;\n  grid-row: 1;\n}\n\n.site-header .header-top--stacked nav {\n  grid-column: 1 / -1;\n  grid-row: 2;\n  justify-self: stretch;\n  width: 100%;\n}\n\n.site-header .header-top--stacked nav .nav-inner {\n  gap: 0.75rem;\n  justify-content: flex-start;\n}\n\n.site-header .header-top--stacked nav a {\n  font-size: 0.82rem;\n}\n\n@media (max-width: 480px) {\n  .site-header .header-top {\n    padding: 0.85rem 0.5rem;\n  }\n\n  .header-logo {\n    height: 34px;\n    max-width: min(140px, 42vw);\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .header-actions {\n    gap: 0.35rem;\n  }\n\n  .lang-toggle {\n    width: 32px;\n    height: 32px;\n  }\n\n  .globe-icon {\n    width: 18px;\n    height: 18px;\n  }\n\n  .btn-header-login {\n    padding: 0.35rem 0.65rem;\n    font-size: 0.78rem;\n  }\n\n  .profile-toggle {\n    gap: 0.35rem;\n  }\n\n  .profile-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 0.85rem;\n  }\n\n  .profile-name {\n    max-width: 6rem;\n    font-size: 0.78rem;\n  }\n\n  .main-content {\n    padding: 1rem 0;\n  }\n\n  .header-banner {\n    width: 100%;\n    max-width: none;\n    margin-left: 0;\n    margin-right: 0;\n    border-radius: 0;\n    min-height: 0;\n    font-size: 0.95rem;\n    letter-spacing: 0.03em;\n    padding: 0.85rem 0.5rem;\n  }\n}\n\n/* Admin user table */\n.table-responsive {\n  overflow-x: auto;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.admin-table th,\n.admin-table td {\n  padding: 0.6rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  vertical-align: middle;\n}\n\n.admin-table th {\n  font-weight: 600;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.badge-success {\n  background: #d4edda;\n  color: #155724;\n}\n\n.badge-muted {\n  background: rgba(0, 0, 0, 0.08);\n  color: #555;\n}\n\n.badge-warning {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.badge-wishlist {\n  background: #e8d5ff;\n  color: #5b21b6;\n}\n\n.search-log-row--wishlist {\n  background: rgba(139, 92, 246, 0.08);\n}\n\n.search-log-row--wishlist td:first-child {\n  box-shadow: inset 3px 0 0 #8b5cf6;\n}\n\n.search-wishlist-panel {\n  margin-top: 1rem;\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba(139, 92, 246, 0.25);\n  border-radius: 8px;\n  background: rgba(139, 92, 246, 0.06);\n  max-width: 36rem;\n}\n\n.search-wishlist-panel__intro {\n  margin: 0 0 0.5rem;\n}\n\n.search-wishlist-panel__privacy {\n  margin: 0 0 0.75rem;\n  font-size: 0.88rem;\n}\n\n.search-wishlist-panel__success {\n  margin: 0;\n  color: #5b21b6;\n  font-weight: 600;\n}\n\n.admin-table-expand-col {\n  width: 2.5rem;\n}\n\n.admin-table-expand-btn {\n  min-width: 2rem;\n  padding: 0.2rem 0.4rem;\n  line-height: 1;\n}\n\n.admin-table-row-expanded td {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.admin-user-detail-row td {\n  padding: 0;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.admin-user-detail {\n  padding: 1rem 1.25rem 1.25rem 2.75rem;\n}\n\n.admin-user-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.75rem 1.5rem;\n  margin: 0;\n}\n\n.admin-user-detail-field dt {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #666;\n  margin-bottom: 0.15rem;\n}\n\n.admin-user-detail-field dd {\n  margin: 0;\n  font-size: 0.9rem;\n  word-break: break-word;\n}\n\n.admin-user-edit-form {\n  margin-bottom: 0;\n}\n\n.admin-user-edit-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.75rem 1.5rem;\n}\n\n.admin-user-checkbox-field label {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-weight: 500;\n  margin-top: 1.75rem;\n}\n\n.admin-user-readonly-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.75rem 1.5rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.admin-user-readonly-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.admin-user-readonly-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #666;\n}\n\n.admin-user-readonly-value {\n  font-size: 0.9rem;\n  word-break: break-word;\n}\n\n.admin-user-password-form {\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.admin-user-password-title {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.subsection-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n/* Rental availability calendar */\n.rental-date-picker {\n  margin-bottom: 0.75rem;\n}\n\n.rental-date-picker__calendar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.rental-date-picker__calendar--disabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n.rental-date-picker__loading {\n  margin: 0 0 0.5rem;\n  font-size: 0.85rem;\n}\n\n.rental-date-picker__fetch-error {\n  margin-bottom: 0.5rem;\n  width: 100%;\n}\n\n/* Doubled class so these beat react-day-picker's own .rdp-root defaults, which load later. */\n.rdp-root.rental-day-picker {\n  --rdp-accent-color: #252629;\n  --rdp-accent-background-color: #c7dbb5;\n  --rdp-today-color: #4a7a35;\n}\n\n.rental-day-picker {\n  --rdp-day-height: 36px;\n  --rdp-day-width: 36px;\n  font-size: 0.9rem;\n}\n\n.rental-day-picker .rdp-day--unavailable {\n  background: #E8E3DC;\n  color: #8a847b;\n  font-weight: 600;\n}\n\n.rental-day-picker .rdp-day--preview:not(.rdp-disabled) {\n  background: rgba(199, 219, 181, 0.45);\n}\n\n.rental-date-picker__legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1rem;\n  justify-content: center;\n  margin-bottom: 0.35rem;\n  font-size: 0.8rem;\n}\n\n.rental-date-picker__legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.rental-date-picker__legend-item::before {\n  content: '';\n  width: 14px;\n  height: 14px;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.rental-date-picker__legend-item--unavailable::before {\n  background: #E8E3DC;\n  border-color: #DDD8D0;\n}\n\n.rental-date-picker__legend-item--selected::before {\n  background: #c7dbb5;\n  border-color: #252629;\n}\n\n.rental-date-picker__fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.rental-date-picker__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  min-width: 0;\n}\n\n.rental-date-picker__field--active {\n  border-color: #252629;\n  box-shadow: 0 0 0 2px #c7dbb5;\n}\n\n.rental-date-picker__field--error {\n  border-color: #c62828;\n}\n\n.rental-date-picker__field-label {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.rental-date-picker__field-value {\n  font-weight: 600;\n  color: #252629;\n}\n\n.rental-date-picker__field-value--empty {\n  font-weight: 400;\n  color: #888;\n}\n\n/* Rent modal steps */\n.rent-steps {\n  display: flex;\n  gap: 0.5rem;\n  list-style: none;\n  margin: 0 0 1rem;\n  padding: 0;\n  font-size: 0.85rem;\n  color: #888;\n}\n\n.rent-steps__item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 3px solid #e0e0e0;\n  min-width: 0;\n}\n\n.rent-steps__item--done {\n  color: #444;\n  border-bottom-color: #c8dcb7;\n}\n\n.rent-steps__item--current {\n  color: #252629;\n  font-weight: 600;\n  border-bottom-color: #252629;\n}\n\n.rent-steps__number {\n  flex-shrink: 0;\n  width: 1.4rem;\n  height: 1.4rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #eceff1;\n  font-size: 0.75rem;\n}\n\n.rent-steps__item--current .rent-steps__number {\n  background: #252629;\n  color: #fff;\n}\n\n.rent-assurances {\n  list-style: none;\n  margin: 0.75rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-size: 0.875rem;\n  color: #444;\n}\n\n.rent-assurances__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.rent-assurances__item::before {\n  content: '✓';\n  flex-shrink: 0;\n  width: 22px;\n  text-align: center;\n  color: #4a7a35;\n  font-weight: 700;\n}\n\n.rent-assurances__item--guarantee::before {\n  display: none;\n}\n\n.rent-assurances__item img {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.rent-location {\n  margin-top: 1rem;\n}\n\n.rent-location__title {\n  margin: 0;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.rent-location__hint {\n  margin: 0.15rem 0 0.5rem;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.rent-contact-preview {\n  padding: 0.75rem;\n  border: 1px solid var(--color-border, #ddd);\n  border-radius: 6px;\n  background: var(--color-surface, #fafafa);\n  font-size: 0.875rem;\n}\n\n.rent-contact-preview__title {\n  margin: 0 0 0.35rem;\n  color: #444;\n}\n\n.rent-contact-preview__list {\n  list-style: none;\n  margin: 0 0 0.35rem;\n  padding: 0;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.rent-contact-preview__edit {\n  font-size: 0.8rem;\n}\n\n.rent-summary {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.35rem 1rem;\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n}\n\n.rent-summary dt {\n  color: #666;\n}\n\n.rent-summary dd {\n  margin: 0;\n  font-weight: 600;\n}\n\n.rent-summary__notes {\n  font-weight: 400 !important;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.rent-legal {\n  font-size: 0.82rem;\n  color: #666;\n}\n\n.rent-legal__title {\n  margin: 0 0 0.35rem;\n  font-weight: 600;\n  color: #444;\n}\n\n.rent-legal__list {\n  margin: 0 0 0.5rem;\n  padding-left: 1.1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.rent-terms-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0 0 0.5rem;\n  font: inherit;\n  font-size: 0.85rem;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.manage-unavailable__list {\n  list-style: none;\n  margin: 0 0 0.75rem;\n  padding: 0;\n}\n\n.manage-unavailable__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--color-border, #ddd);\n}\n\n.manage-unavailable__item:last-child {\n  border-bottom: none;\n}\n\n.manage-unavailable__form {\n  margin-top: 0.5rem;\n}\n\n/* Categories overview */\n.categories-page {\n  max-width: 1120px;\n  margin: 0 auto;\n}\n\n.category-tile-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.25rem;\n}\n\n.category-tile {\n  position: relative;\n  display: block;\n  aspect-ratio: 4 / 5;\n  border-radius: 20px;\n  background: #F3EFE9;\n  overflow: hidden;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.category-tile-heading {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n  padding: 2.5rem 1rem 1rem;\n  font-family: \"berthold-block-w1g\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  text-transform: uppercase;\n  color: #252629;\n  line-height: 1.2;\n}\n\n.category-tile:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.category-tile:focus-visible {\n  outline: 2px solid #252629;\n  outline-offset: 2px;\n}\n\n.category-tile-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 3.5rem;\n  width: 100%;\n  height: 100%;\n  padding: 1.25rem 1rem 0.5rem;\n  box-sizing: border-box;\n  object-fit: contain;\n  object-position: center;\n}\n\n@media (max-width: 768px) {\n  .category-tile-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .category-tile-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.75rem;\n  }\n\n  .category-tile {\n    border-radius: 14px;\n  }\n\n  .category-tile-heading {\n    padding: 2rem 0.6rem 0.75rem;\n    font-size: 0.72rem;\n  }\n}\n\n/* Search view toggle */\n.view-toggle {\n  display: inline-flex;\n  gap: 0;\n  margin-bottom: 1rem;\n  border: 1px solid #E8E3DC;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.view-toggle__btn {\n  border: none;\n  background: transparent;\n  padding: 0.45rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #252629;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.view-toggle__btn:hover {\n  background: #f6f1e4;\n}\n\n.view-toggle__btn--active {\n  background: #252629;\n  color: #fff;\n}\n\n.view-toggle__btn--active:hover {\n  background: #252629;\n}\n\n.view-toggle__btn:focus-visible {\n  outline: 2px solid #252629;\n  outline-offset: -2px;\n}\n\n/* Search results map */\n.search-results-map {\n  position: relative;\n  width: 100%;\n  min-height: 60vh;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid #E8E3DC;\n  margin-bottom: 1rem;\n  z-index: 1;\n}\n\n.search-results-map__canvas {\n  width: 100%;\n  height: 60vh;\n  min-height: 360px;\n}\n\n.search-results-map--loading::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(246, 241, 228, 0.55);\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.map-results-notice {\n  font-size: 0.85rem;\n  margin: 0 0 0.75rem;\n}\n\n.leaflet-marker-icon.map-price-marker {\n  width: auto !important;\n  height: auto !important;\n  transform: translate(-50%, -100%);\n  background: #fff;\n  color: #252629;\n  border: 1px solid #E8E3DC;\n  border-radius: 999px;\n  padding: 0.35rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n  transition: transform 0.12s, background 0.12s, border-color 0.12s, box-shadow 0.12s;\n}\n\n.leaflet-marker-icon.map-price-marker:hover,\n.leaflet-marker-icon.map-price-marker--selected {\n  background: #252629;\n  color: #fff;\n  border-color: #252629;\n  transform: translate(-50%, -100%) scale(1.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n  z-index: 1000 !important;\n}\n\n.map-cluster-icon-wrap {\n  background: transparent;\n  border: none;\n}\n\n.map-cluster-marker {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #252629;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: 700;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  border: 2px solid #fff;\n}\n\n.map-product-card {\n  position: absolute;\n  z-index: 1100;\n  transform: translate(-50%, calc(-100% - 14px));\n  display: flex;\n  gap: 0.5rem;\n  width: min(240px, calc(100% - 1rem));\n  padding: 0.5rem;\n  background: #fff;\n  border: 1px solid #E8E3DC;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.14);\n  pointer-events: none;\n}\n\n.map-product-card__image {\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #EDE8E0;\n}\n\n.map-product-card__image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.map-product-card__placeholder {\n  width: 100%;\n  height: 100%;\n  background: #EDE8E0;\n}\n\n.map-product-card__body {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.15rem;\n}\n\n.map-product-card__name {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #252629;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.map-product-card__price {\n  font-size: 0.75rem;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .search-results-map,\n  .search-results-map__canvas {\n    min-height: 70vh;\n    height: 70vh;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
